import { Modal, Table } from "antd";
import { useTranslation } from "react-i18next";

const EmailLoopMemberModal = ({ open, onCancel, members = [], loading = false }) => {
    const { t } = useTranslation();
    const columns = [
        { title: t("email_loop.member.employee_no"), dataIndex: "employeeNo" },
        { title: t("email_loop.member.name"), dataIndex: "name" },
    ];
    return (
        <Modal title={t("email_loop.member.title")} open={open} onCancel={onCancel} footer={null} width={720} zIndex={1050}>
            <Table rowKey="id" columns={columns} dataSource={members} loading={loading} pagination={{ pageSize: 10 }} />
        </Modal>
    );
};

export default EmailLoopMemberModal;